import React, { useCallback } from 'react';
import {
	GLOBAL_CONTAINERS_MARK,
	GLOBAL_CONTAINERS_START_MARK,
	GLOBAL_CONTAINERS_END_MARK,
} from '@jira/platform__page-container-constants/src/index.tsx';
import PerformanceMark from '@atlassian/jira-common-performance/src/set-performance-mark.tsx';
import { setInitialPageLoadTimingFromPerformanceMarks } from '@atlassian/jira-spa-performance-breakdown/src/utils/performance-marks-tools/index.tsx';
import { GlobalContainers } from '../global-containers/main.tsx';
import type { PageContainerProps } from './types.tsx';

// Instantiates GlobalContainers and measures how long it took to do so.
// The `GlobalContainers` component sets a number of important contexts, including the Router and the JiraRelayEnvironmentProvider.
// We're doing this in a dedicated component so that it's easier to say "everything under here works as you expect, everything above won't".
export const GlobalContextProvider = (props: PageContainerProps): React.JSX.Element => {
	const { id, locale, messages, Router, routerLinkComponent, children } = props;
	const pageContainerPerformanceTiming = useCallback(() => {
		setInitialPageLoadTimingFromPerformanceMarks(
			GLOBAL_CONTAINERS_MARK,
			GLOBAL_CONTAINERS_START_MARK,
			GLOBAL_CONTAINERS_END_MARK,
			true,
			false,
		);
	}, []);

	return (
		<>
			<PerformanceMark metricKey={GLOBAL_CONTAINERS_START_MARK} />
			<GlobalContainers
				id={id}
				locale={locale}
				messages={messages}
				Router={Router}
				routerLinkComponent={routerLinkComponent}
			>
				<PerformanceMark
					metricKey={GLOBAL_CONTAINERS_END_MARK}
					onSet={pageContainerPerformanceTiming}
				/>
				{children}
			</GlobalContainers>
		</>
	);
};
